/* eslint-disable max-len */
import React, { useEffect, Fragment } from 'react'

import styles from '../styles/StandardChat.css'
import Icon from './Icon'

export default function StandardChat(props) {
  useEffect(() => {
    const feedEl = document.getElementById('chat-wrapper')
    feedEl.scrollTo({ top: feedEl.scrollHeight, behavior: 'smooth' })
  }, [props.chatFeed])

  function processText(text) {
    const URL_REGEX = /(([a-z]+:\/\/)?(([a-z0-9\-]+\.)+([a-z]{2}|aero|arpa|biz|com|coop|edu|gov|info|int|jobs|mil|museum|name|nato|net|org|pro|travel|local|internal))(:[0-9]{1,5})?(\/[a-z0-9_\-\.~]+)*(\/([a-z0-9_\-\.]*)(\?[a-z0-9+_\-\.%=&amp;]*)?)?(#[a-zA-Z0-9!$&'()*+.=-_~:@/?]*)?)(\s+|$)/gi
    const URL_INTER_INDENTIFIER = '**url**:'
    const interText = text.replace(URL_REGEX, (url) => {
      const cleanURL = url.replace('\n', '')
      return '|||' + URL_INTER_INDENTIFIER + cleanURL + '|||' + url.replace(cleanURL, '')
    })
    return interText.split('|||').map((value, index) => {
      if (value.includes(URL_INTER_INDENTIFIER)) {
        const url = value.replace(URL_INTER_INDENTIFIER, '')
        return <a
          key={'url-' + index}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
        >
          {url}
        </a>
      }
      return value
    })
  }

  return (
    <div className={styles['chat-wrapper']} id='chat-wrapper' style={props.styles}>
      {props.chatFeed.map((message, index) => {
        return (
          <div
            key={'msg-' + index}
            className={message.type === 'question'
              ? styles['question-chat']
              : styles['answer-chat']}
          >
            <div className={styles.avatar}>
              {message.type === 'answer' ? props.answerAvatar : props.userAvatar}
            </div>
            <div className={styles['chat-box']}>
              {(message.type === 'answer')
                ? <div className={styles['icon-and-text']}>
                  <Icon
                    className={(message.isCompleted || message.isLoading) ? styles['active-icon'] : ''}
                    icon={message.isLoading ? 'cube-outline' : 'cube'}
                    key={(message.isLoading ? 'cube-outline' : 'cube') + `-${index}`}
                  />
                  <div>{processText(message.text)}</div>
                </div>
                : <>{processText(message.text)}</>
              }
            </div>
          </div>
        )
      })}
      <div
        style={{ width: '100%', height: props.paddingBottom || '0em' }}
      >
        {/* bottom padding */}
      </div>
    </div>
  )
}
